import { AppState } from '../../root-reducer';

export const selectTileLayersOpacity = (state: AppState) => state.mapTileLayerDomain.tileLayerOpacity;

export const selectPinnedTileLayers = (state: AppState) => state.mapTileLayerDomain.pinnedTileLayers;

// TODO This should be removed when #4615 is reviewed is unused but seems to be tied into a few components
// but no longer doing anything
export const selectHighlightedTileLayerId = (state: AppState) => state.mapTileLayerDomain.highlightedTileLayer;
